import { render, staticRenderFns } from "./ExaminationAttributes.vue?vue&type=template&id=fefc9f20&scoped=true&"
import script from "./ExaminationAttributes.vue?vue&type=script&lang=js&"
export * from "./ExaminationAttributes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fefc9f20",
  null
  
)

export default component.exports